/**
 * Extract the partition-agnostic session identifier from a messageChainId.
 *
 * messageChainId format: `${streamId}-${streamPartition}-${userIdHex}-${randomPart}`
 * Example: `tv.streamr.eth/gct85u268pm-1-023b98...-16t26`
 *
 * The randomPart (e.g., "16t26") is unique per browser window and doesn't
 * change across partitions, so we use it for session matching.
 */
function extractSessionSuffix(messageChainId) {
    const lastDashIndex = messageChainId.lastIndexOf('-');
    if (lastDashIndex === -1) {
        return messageChainId;
    }
    return messageChainId.substring(lastDashIndex + 1);
}
/**
 * The stream partition a message chain publishes on, parsed from the end of
 * the messageChainId (the stream id itself may contain dashes).
 */
/** the stream id a message chain id was derived from (the id may contain '-') */
export function streamIdFromMessageChainId(messageChainId) {
    const parts = messageChainId.split('-');
    if (parts.length < 4)
        return undefined;
    return parts.slice(0, parts.length - 3).join('-');
}
export function partitionFromMessageChainId(messageChainId) {
    const parts = messageChainId.split('-');
    if (parts.length < 4)
        return undefined;
    const partition = Number(parts[parts.length - 3]);
    return Number.isInteger(partition) && partition >= 0
        ? partition
        : undefined;
}
export function createUserSessionId(userId, messageChainId) {
    const sessionSuffix = extractSessionSuffix(messageChainId);
    const normalizedUserId = userId.startsWith('0x') || userId.startsWith('0X')
        ? userId.slice(2)
        : userId;
    return `${normalizedUserId}:${sessionSuffix}`;
}
